<span [ngSwitch]="showFormatHourMinute">
<p *ngSwitchCase="true">
    <app-fichajes_hours_minutes></app-fichajes_hours_minutes>
</p>
<p *ngSwitchCase="false">
    <app-fichajes-decimal></app-fichajes-decimal>
</p>

<p *ngSwitchDefault>

</p>
</span>